import { useSelector } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import HoldCancelClubMembership from 'profile/clubMembership/holdCancel/HoldCancelClubMembership';
import UpcomingCancelMessage from 'profile/clubMembership/holdCancel/UpcomingCancelMessage';
import UpcomingHoldMessage from 'profile/clubMembership/holdCancel/UpcomingHoldMessage';

import PaymentDetails from '../../components/PaymentDetails';
import ShipTo from '../../components/ShipTo';
import { isUpcomingHold, isUpcomingCancel } from '../../helpers';
import ClubShipDate from '../../shipment/components/subscription/ClubShipDate';

import FrequencyDetails from './subscription/FrequencyDetails';
import ShipItNow from './subscription/ShipItNow';
import ShipmentItemsPricingFromProducts from './subscription/ShipmentItemsPricingFromProducts';

const ActiveWithShipmentMembership = (props) => {
  const { clubMembership, router = 'router' } = props;
  const clubSubscriptionShipment = useSelector(
    (state) =>
      state.clubSubscriptionShipment.data[
        clubMembership.activeClubSubscriptionShipmentId
      ]
  );

  return (
    <div className="c7-account__club-status">
      <div>
        <h3>
          {clubMembership.club.title} {renderUpcomingHold(clubMembership)}
        </h3>
        <ClubShipDate
          clubSubscriptionShipment={clubSubscriptionShipment}
          router={router}
        />
        <br />
        <UpcomingCancelMessage clubMembership={clubMembership} />
        <UpcomingHoldMessage clubMembership={clubMembership} />
        {router === 'router' && (
          <ShipItNow
            clubMembership={clubMembership}
            clubSubscriptionShipment={clubSubscriptionShipment}
          />
        )}
        <br />
        <br />
      </div>

      <div className="c7-account-row">
        <div>
          <div className="c7-account-tile__section">
            <ShipTo clubMembership={clubMembership} />
          </div>
          <br />
          <div className="c7-account-tile__section">
            <PaymentDetails clubMembership={clubMembership} />
          </div>
          <div className="c7-account-tile__section">
            <FrequencyDetails clubMembership={clubMembership} />
          </div>

          <br />
          {router === 'router' && (
            <HoldCancelClubMembership
              clubMembership={clubMembership}
              clubSubscriptionShipment={clubSubscriptionShipment}
            />
          )}
          {router === 'noRouter' && (
            <div className="c7-club-actions c7-club-actions--hold-cancel">
              <a href={`/profile/club-membership/${clubMembership.id}`}>
                Edit club membership
              </a>
            </div>
          )}
        </div>
        <ShipmentItemsPricingFromProducts
          clubMembership={clubMembership}
          clubSubscriptionShipment={clubSubscriptionShipment}
          isPersonalizationBlock={router === 'noRouter' || false}
        />
      </div>
    </div>
  );
};

const renderUpcomingHold = (clubMembership) => {
  if (isUpcomingCancel(clubMembership)) {
    return (
      <>
        <em>(Upcoming Cancellation)</em>
      </>
    );
  }
  if (isUpcomingHold(clubMembership)) {
    return (
      <>
        <em>(Upcoming Hold)</em>
      </>
    );
  }
  return null;
};

export default ActiveWithShipmentMembership;
